import React from 'react';
import PropTypes from 'prop-types';
import { Anchor, Text } from '@pinpoint/design-kit';

import { withFixedTitle } from 'src/components';

function Summary({ customerGroup, toggle, analysis }) {
  return (
    <Text m={{ x: '1rem', b: '1rem' }} textSize="subheader">
      Below are the most prominent personality types of your&nbsp;{customerGroup}.
      <br />
      Our analysis has found that they are, on average,{analysis}. Based on this, we can offer some color and word
      recommendations for your marketing materials that are likely to resonate with them. The strength of each
      personality type indicates how different these shoppers are from the population average - in other words, how
      actionable each one is from a marketing perspective. Check the&nbsp;
      <Anchor onClick={() => toggle()}>Personality Explorer</Anchor>
      &nbsp;to learn more and get the details of this analysis.
    </Text>
  );
}

Summary.propTypes = {
  customerGroup: PropTypes.string.isRequired,
  analysis: PropTypes.string.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default withFixedTitle(Summary);
